import type { FC } from 'react'
import React from 'react'

import Image from '@components/SuspenseImage'

import styles from './index.module.css'

const AccessErrorPage: FC = () => {
  return (
    <div className={styles.main}>
      <div className={styles.textPart}>
        <h4 className={styles.descrTitle}>You need access</h4>
        <p className={styles.descrText}>
          Ask your Approveit workspace admin for access <mark>{`(Team > Invite)`}</mark>, or switch to an account with
          access.
        </p>
      </div>
      <Image className={styles.errorIcon} src="/Error.png" alt="access error" />
    </div>
  )
}

export default AccessErrorPage
